/**
 * Resource Center link URLs.
 */

/** Get Help – Support Center (Freshworks auth). */
export const SUPPORT_CENTER_URL =
    'https://relometrics-org.myfreshworks.com/login/auth/1748718818965?client_id=451979510707337272&redirect_uri=https%3A%2F%2Frelometrics.freshdesk.com%2Ffreshid%2Fcustomer_authorize_callback%3Fhd%3Drelometrics.freshdesk.com';

/** Media Valuation 101 / Methodology Overview. */
export const METHODOLOGY_OVERVIEW_URL =
    'https://relometrics.freshdesk.com/support/solutions/articles/156000369183-media-valuation-101';

/** API Integration / Technical Documentation (PDF). */
export const API_DOCUMENTATION_URL =
    'https://9393297.fs1.hubspotusercontent-na1.net/hubfs/9393297/Relo%20API%20Documentation%20(5).pdf';
